module.exports = __webpack_public_path__ + "static/img/makehole4.aa8171f4.png";